/* Form Radio - Set */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRadioSet( radio , value ) {
    
    /* Loop Radio Buttons */
    jQuery( 'input[name="' + radio.attr( 'name' ) + '"]' ).each(function( index ) {

        /* If Selected */
        if ( jQuery( this ).val() == value ) {

            /* Add Class */
            jQuery( this ).parent().addClass( 'checked' );
    
            /* Check Radio */
            jQuery( this ).prop( 'checked' , true );
            
        } else {
            
            /* Remove Class */
            jQuery( this ).parent().removeClass( 'checked' );
    
            /* Uncheck Radio */
            jQuery( this ).prop( 'checked' , false );
            
        }
    
    });
    
}

/* Form Radio - Reset */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRadioReset( radio ) {
    
    /* Remove Class */
    jQuery( 'input[name="' + radio.attr( 'name' ) + '"]' ).parent().removeClass( 'checked' );
    
    /* Unheck Radio */
    jQuery( 'input[name="' + radio.attr( 'name' ) + '"]' ).prop( 'checked' , false );
    
}

/* Form Radio - Click */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRadioClick( event ) {
    
    /* Prevent Default */
    event.preventDefault();

    /* Setup */
    var radio = jQuery( this ).find( 'input' );
        
    /* Check Status */
    if ( !radio.prop( 'checked' ) && !radio.prop( 'disabled' ) ) {
                
        /* Remove Class */
        jQuery( 'input[name="' + radio.attr( 'name' ) + '"]' ).parent().removeClass( 'checked' );
            
        /* Check Radio */
        radio.prop( 'checked' , true );
        radio.parent().addClass( 'checked' );
                
        /* Trigger Change Event */
        radio.triggerHandler( 'change' );
                
    }
    
    /* If Has Validation */    
    if ( radio.hasClass( 'form-validated' ) ) {
        radio.valid();
    }

}

/* Form Radio - Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsRadioInit() {

    /* Loop Radios */
    jQuery( 'input.form-radio' ).each(function() {
        
        /* Get Radio */
        var radio = jQuery( this );
        
        /* Template */
        radio.wrap( '<label></label>' );
        
        /* Move Classes */
        radio.parent().attr( 'class' , radio.attr( 'class' ) );
        radio.removeClass();
        
        /* If Label */
        if ( radio.data( 'label' ) !== undefined && radio.data( 'label' ) ) {
            radio.parent().append( radio.data( 'label' ) );    
        }
        
        /* Add Icon */
        radio.parent().append( '<i></i>' );
        
        /* Checked */
        if ( radio.prop( 'checked' ) ) {
        
            /* Add Class */
            radio.parent().addClass( 'checked' );
        
        }
        
        /* Add Click Event */
        radio.parent().on( 'click' , ipcrimeFormsRadioClick );
        
        /* Disabled */
        ipcrimeFormsStyleDisabled( radio );

    });

}